import { usePrefectureDashboardData } from '@/hooks/usePrefectureDashboardData'
import { useFilterOptions } from '@/hooks/useFilterOptions'
import useFilterStore from '@/store/useFilterStore'

const ChampionshipHistory = () => {
  const { data, isLoading, error } = usePrefectureDashboardData()
  const { data: filterOptions } = useFilterOptions()
  const { selectedPrefectures } = useFilterStore()

  // 選択されている都道府県の名前を取得
  const getSelectedPrefectureNames = () => {
    if (!filterOptions?.prefectures || selectedPrefectures.length === 0) {
      return []
    }
    
    return selectedPrefectures
      .map(id => filterOptions.prefectures.find(p => p.id === id)?.name)
      .filter(Boolean) as string[]
  }

  const selectedPrefectureNames = getSelectedPrefectureNames()

  // 都道府県が選択されているかどうかを判定
  const isSelectedPrefecture = (prefectureName: string) => {
    return selectedPrefectureNames.includes(prefectureName)
  }

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded mb-4"></div>
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-12 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-500">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { championshipHistory } = data

  if (championshipHistory.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">優勝履歴</h2>
        <p className="text-gray-500">優勝履歴データがありません</p>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">優勝・準優勝履歴</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">年度</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">大会名</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">世代</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">優勝チーム</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">準優勝チーム</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">スコア</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">都道府県</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {championshipHistory.slice(0, 20).map((item) => (
              <tr key={`${item.year}-${item.tournamentName}`}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {item.year}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.tournamentName}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.generation}
                </td>
                <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium ${
                  isSelectedPrefecture(item.prefectureName) ? 'text-green-600' : 'text-gray-900'
                }`}>
                  {item.championTeam}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.runnerUpTeam}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.finalScore}
                </td>
                <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium ${
                  isSelectedPrefecture(item.prefectureName) ? 'text-green-600' : 'text-gray-900'
                }`}>
                  {item.prefectureName}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ChampionshipHistory
